import { createSlice } from '@reduxjs/toolkit';

export const brSlice = createSlice({
    name: "roles",
    initialState: {
        modalStatus: false,
        selectedRole: null
    },
    reducers: {
        openAddRoleModal: (state) => {
        state.modalStatus = "add";
        },
        openEditRoleModal: (state, action) => {
        state.modalStatus = "edit";
        state.selectedRole = action.payload;
        },
        openDeleteRoleModal: (state, action) => {
        state.modalStatus = "delete";
        state.selectedRole = action.payload;
        },
        closeRoleModal: (state) => {
        state.modalStatus = false;
        state.selectedRole = null;
        }
    }
});

export const {
    openAddRoleModal,
    openEditRoleModal,
    openDeleteRoleModal,
    closeRoleModal
} = brSlice.actions;

export default brSlice.reducer;